import { DividaResource } from '@/models/resources';
import { DividasOrderingService } from '../DividasOrderingService';
import { IOrdenacaoStrategy } from './interfaces/IOrdenacaoStrategy';
import { OrdenacaoPorMaiorReceitaStrategy } from './strategies/OrdenacaoPorMaiorReceitaStrategy';
import { OrdenacaoPorModelagemAcertoStrategy } from './strategies/OrdenacaoPorModelagemAcertoStrategy';
import { OrdenacaoPorOrdemChegadaStrategy } from './strategies/OrdenacaoPorOrdemChegadaStrategy';
import { OrdenacaoPorOrdemSalvaStrategy } from './strategies/OrdenacaoPorOrdemSalvaStrategy';
import { TipoOrdenacao } from './types/TipoOrdenacao';

/**
 * Context que gerencia as estratégias de ordenação e faz o chaveamento
 */
export class DividasOrderingContext {
  private strategies: Map<TipoOrdenacao, IOrdenacaoStrategy>;

  constructor(orderingService: DividasOrderingService) {
    this.strategies = new Map<TipoOrdenacao, IOrdenacaoStrategy>([
      [TipoOrdenacao.ORDEM_SALVA, new OrdenacaoPorOrdemSalvaStrategy(orderingService)],
      [TipoOrdenacao.MAIOR_RECEITA, new OrdenacaoPorMaiorReceitaStrategy(orderingService)],
      [
        TipoOrdenacao.MODELAGEM_ACERTO,
        new OrdenacaoPorModelagemAcertoStrategy(orderingService),
      ],
      [TipoOrdenacao.ORDEM_CHEGADA, new OrdenacaoPorOrdemChegadaStrategy()],
    ]);
  }

  /**
   * Ordena múltiplos lotes, cada um com seu tipo de ordenação
   * @param lotes Array de arrays de dívidas (cada array representa um lote)
   * @param tiposOrdenacao Array de tipos de ordenação (um por lote, na mesma ordem)
   * @returns Array único de dívidas ordenado e concatenado
   */
  ordenarLotes(
    lotes: DividaResource[][],
    tiposOrdenacao: TipoOrdenacao[],
  ): DividaResource[] {
    if (lotes.length !== tiposOrdenacao.length) {
      throw new Error('Número de lotes deve ser igual ao número de tipos de ordenação');
    }

    const lotesOrdenados = lotes.map((lote, index) => {
      const tipo = tiposOrdenacao[index];
      const strategy = this.strategies.get(tipo);

      if (!strategy) {
        throw new Error(`Estratégia de ordenação não encontrada para o tipo: ${tipo}`);
      }

      return strategy.ordenar(lote, tipo);
    });

    // Concatena todos os lotes ordenados
    return lotesOrdenados.flat();
  }
}
